module.exports = __webpack_public_path__ + "img/register-v2-dark.d29489f4.svg";